// extracted by mini-css-extract-plugin
export default {"alert-danger":"rgb(218, 30, 40)","gray-30":"rgb(193, 198, 205)","clear":"styles_clear__8XAKl","clearIcon":"styles_clearIcon__sM52u"};